import {
  FiCopy,
  handleCopy,
} from "@/components/common/commonFunction/handleCopy";
import React, { useState } from "react";

function TruncateText() {
  const [text, setText] = useState("");
  const [copy, setCopy] = useState(false);
  const [changeupTrunc, setChangeupTrunc] = useState("");
  const [truncateln, setTruncateln] = useState("");
  const [errors, setErrors] = useState("");

  const handleOnErase = () => {
    setText("");
    setChangeupTrunc("");
    setTruncateln("");
    setCopy(false);
  };

  const handleOnChange = (event) => {
    setErrors("");
    setChangeupTrunc("");
    setCopy(false);
    setText(event.target.value);
  };

  const handleTruncateClick = () => {
    if (!text?.trim()) {
      setErrors("* Please enter text.");
      return;
    }
    const truncLength = Number(truncateln);
    if (isNaN(truncLength)) {
      setErrors("* Invalid truncation length.");
      return;
    }
    const truncatedText =
      text.length > truncLength ? `${text.slice(0, truncLength)}...` : text;
    setChangeupTrunc(truncatedText);
    setCopy(false);
  };
  return (
    <>
      <div className="main-globally-counter-box">
        {text?.length > 0 && (
          <div className="color-picker-icon">
            <i
              className="fa-solid fa-eraser"
              title="Clear"
              onClick={handleOnErase}
            ></i>
          </div>
        )}
        <div className="counter-text-area">
          <textarea
            className={errors ? "error-input" : ""}
            placeholder="Type text to truncate here..."
            value={text}
            onChange={handleOnChange}
          />
          <span>{errors}</span>
        </div>
      </div>
      <div className="commom-box-new truncate-text-top-alignment">
        <div className="input-new">
          <input
            type="number"
            name="startNumber"
            value={truncateln}
            placeholder="Truncate length"
            onChange={(e) => {
              if (e.target.value) {
                setChangeupTrunc("");
              }
              setTruncateln(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="button lowercase-center-alignment">
        <button onClick={handleTruncateClick}>Truncate Text</button>
      </div>
      {changeupTrunc?.length > 0 && (
        <div className="main-globally-counter-box">
          <div className="copy-textarea-icon-alignment">
            <FiCopy onClick={() => handleCopy(changeupTrunc)} />
            {copy && changeupTrunc && (
              <div>
                <span>Copied</span>
              </div>
            )}
          </div>
          <div className="counter-text-area">
            <textarea
              value={changeupTrunc}
              disabled
              className="text-black"
              readOnly
            />
          </div>
        </div>
      )}
    </>
  );
}
export default TruncateText;
